import { cn } from '../../lib/cn';
import type { ReplenishmentRow } from '../../supplychain/framework';

type Props = { rows?: ReplenishmentRow[] };

export function ReplenishmentPlanningPanel({ rows = [] }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-xs uppercase text-slate-500 dark:border-slate-700">
            <th className="pb-2 pr-4 font-medium">SKU</th>
            <th className="pb-2 pr-4 font-medium">Reorder Qty</th>
            <th className="pb-2 pr-4 font-medium">Days Left</th>
            <th className="pb-2 pr-4 font-medium">Supplier</th>
            <th className="pb-2 font-medium">Expected ROI</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.sku} className="border-b border-slate-100 dark:border-slate-800">
              <td className="py-2.5 pr-4 font-medium">{r.sku}</td>
              <td className="py-2.5 pr-4">{r.qty.toLocaleString()}</td>
              <td className="py-2.5 pr-4">
                <span className={cn(
                  'rounded-full px-2 py-0.5 text-xs font-medium',
                  r.daysLeft <= 10 ? 'bg-error-100 text-error-700 dark:bg-error-950 dark:text-error-300' : 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
                )}>
                  {r.daysLeft}d
                </span>
              </td>
              <td className="py-2.5 pr-4 text-slate-600 dark:text-slate-400">{r.supplier}</td>
              <td className="py-2.5 font-semibold text-brand-600">{r.roi}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
